import {Filter} from '@shared/models/filter.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class PermissionFilterModel extends Filter {

	ald_commodity_id?: any;
	name?: string;
	ald_supplier_code?: any;
	ald_supplier_id?: any;
	type_ids?: number[];
	flag_return_point?: boolean;
	range?: boolean;

	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			Object.assign(this, model);
		}
	}

	clone(): Filter {
		return new PermissionFilterModel(this);
	}

	getFilterUrl(): string {
		return Utilities.getQuery(this);
	}

	newFilter(model?: any): Filter {
		return new PermissionFilterModel(model);
	}
}

